//@flow

import fscreen from 'fscreen';
class FullscreenHelper {
    /**
     * Check if fullscreen mode is enabled
     */
    isEnabled(): boolean {
        if (fscreen.fullscreenElement) return true;
        else return false;
    }

    isSupported(): boolean {
        return fscreen.fullscreenEnabled;
    }

    /**
     * Enable fullscreen mode and return browser prefix
     */
    enable(el?: ?HTMLElement = document.documentElement) {
        fscreen.requestFullscreen(el);
    }

    /**
     * Disable fullscreen mode
     */
    disable() {
        if (this.isEnabled()) {
            fscreen.exitFullscreen();
        }
    }
    addFullScreenChangeListener(handler: Function, options?: Object) {
        fscreen.addEventListener('fullscreenchange', handler, options);
    }
    removeFullScreenChangeListener(handler: Function, options?: Object) {
        fscreen.removeEventListener('fullscreenchange', handler, options);
    }
}

export default new FullscreenHelper();
